<div *ngIf="loading" class="lf-loading"></div>
<router-outlet></router-outlet>
